const ComConfig = [
      {
        env:'pro',
        htmlTitle:'点调查',
        rulePage:{
            ruleLogo:{
                logoName:'logo.png',
                style:'width: 180px;height: 30px;'
            },
            logoTitle:'让你的观点 产生价值',
            ruleList:[
                {
                    icon: 'label-o',
                    des:
                      '受企业的委托，蜂鸟正在收集消费者对商家、品牌、产品的认知、体验和建议。'
                  },
                  {
                    icon: 'label-o',
                    des:
                      '在这里，您分享的每个观点都将得到重视和酬谢，您完整地答完的每一份问卷都将获得现金报酬，通过微信零钱在48小时内支付！'
                  },
                  {
                    icon: 'label-o',
                    des:
                      '我们希望您把蜂鸟推荐给你的朋友，让他们也可以有偿反馈意见。'
                  },
                  {
                    icon: 'label-o',
                    des:
                      '我们希望先了解您的基本情况，以便向您推送合适的任务，在正式答题前，须先请您填答《基础信息问卷》；'
                  },
                  {
                    icon: 'label-o',
                    des:
                      '您应该知道，不真实的信息是无法使用的，如果您填写的信息存在失真或矛盾，您的意见将不被采纳，也无法获取酬金。'
                  }
            ]
        },
        errorPage:{
          titlelogo:'logo1.jpg',
          title: '<span class="mrSpace">让您的观点</span><span>改变未来</span>',
          titleDesPc:['【点调查】是一个调研任务有偿参与平台','您可以通过微信公众号参与调研任务并获得现金回报','目前已累计发布<span style="color:#FFC000">20000+</span>个调研任务， 发放<span style="color:#FFC000">2500万</span>现金奖励'],
          titleDesmoblie:'【点调查】是一个调研任务有偿参与平台，您可以通过微信公众号参与调研任务并获得现金回报，目前已累计发布<span style="color:#FFC000">20000+</span>个调研任务， 发放<span style="color:#FFC000">2500万</span>现金奖励',
          stepBitem:[
            {
              stepBitemT:'注册',
              stepIcoClass:'stepRes',
              stepIco:'person.png',
              stepBitemD:'600万+用户',
              stepBitemD2:'微信公众号快速登录'
            },
            {
              stepBitemT:'答卷',
              stepIcoClass:'stepWri',
              stepIco:'write.png',
              stepBitemD:'2000+任务发布',
              stepBitemD2:'每天都有新任务'
            },
            {
              stepBitemT:'兑奖',
              stepIcoClass:'stepGig',
              stepIco:'gift.png',
              stepBitemD:'2500w奖励发放',
              stepBitemD2:'直接到账微信钱包'
            },
          ],
          ewm:{
            ico:'code.png',
            codeText:'关注公众号',
            codeText2:'答卷更方便'
          }
        }
    },
    {
        env:'test',
        htmlTitle:'点调查',
        rulePage:{
            ruleLogo:{
                logoName:'logo.png',
                style:'width: 180px;height: 30px;'
            },
            logoTitle:'让你的观点 产生价值',
            ruleList:[
                {
                    icon: 'label-o',
                    des:
                      '受企业的委托，蜂鸟正在收集消费者对商家、品牌、产品的认知、体验和建议。'
                  },
                  {
                    icon: 'label-o',
                    des:
                      '在这里，您分享的每个观点都将得到重视和酬谢，您完整地答完的每一份问卷都将获得现金报酬，通过微信零钱在48小时内支付！'
                  },
                  // {
                  //   icon: 'label-o',
                  //   des:
                  //     '我们希望您把蜂鸟推荐给你的朋友，让他们也可以有偿反馈意见，更重要的是您将获取好友酬金金额10%的佣金奖励，同样是“当日即付”哦！'
                  // },
                  {
                    icon: 'label-o',
                    des:
                      '我们希望您把蜂鸟推荐给你的朋友，让他们也可以有偿反馈意见。'
                  },
                  {
                    icon: 'label-o',
                    des:
                      '我们希望先了解您的基本情况，以便向您推送合适的任务，在正式答题前，须先请您填答《基础信息问卷》；'
                  },
                  {
                    icon: 'label-o',
                    des:
                      '您应该知道，不真实的信息是无法使用的，如果您填写的信息存在失真或矛盾，您的意见将不被采纳，也无法获取酬金。'
                  }
            ]
        },
        errorPage:{
          titlelogo:'logo1.jpg',
          title: '<span class="mrSpace">让您的观点</span><span>改变未来</span>',
          titleDesPc:['【点调查】是一个调研任务有偿参与平台','您可以通过微信公众号参与调研任务并获得现金回报','目前已累计发布<span style="color:#FFC000">20000+</span>个调研任务， 发放<span style="color:#FFC000">2500万</span>现金奖励'],
          titleDesmoblie:'【点调查】是一个调研任务有偿参与平台，您可以通过微信公众号参与调研任务并获得现金回报，目前已累计发布<span style="color:#FFC000">20000+</span>个调研任务， 发放<span style="color:#FFC000">2500万</span>现金奖励',
          stepBitem:[
            {
              stepBitemT:'注册',
              stepIcoClass:'stepRes',
              stepIco:'person.png',
              stepBitemD:'600万+用户',
              stepBitemD2:'微信公众号快速登录'
            },
            {
              stepBitemT:'答卷',
              stepIcoClass:'stepWri',
              stepIco:'write.png',
              stepBitemD:'2000+任务发布',
              stepBitemD2:'每天都有新任务'
            },
            {
              stepBitemT:'兑奖',
              stepIcoClass:'stepGig',
              stepIco:'gift.png',
              stepBitemD:'2500w奖励发放',
              stepBitemD2:'直接到账微信钱包'
            },
          ],
          ewm:{
            ico:'code.png',
            codeText:'关注公众号',
            codeText2:'答卷更方便'
          }
        }
    },
    {
        env:'vendor',
        htmlTitle:'中创调查',
        rulePage:{
            ruleLogo:{
                logoName:'logo-zc.jpg',
                style:'width: 175px;height: 124px;'
            },
            logoTitle:'',
            ruleList:[
                  {
                    icon: 'label-o',
                    des:
                      '在这里，您分享的每个观点都将得到重视，未来我们将会通过微信邀请您参加部分项目，在您完整地答完的每一份问卷都将通过微信红包获得现金报酬。'
                  },
                  {
                    icon: 'label-o',
                    des:
                      '您应该知道，不真实的信息是无法使用的，如果您填写的信息存在失真或矛盾，您的意见将不被采纳，也无法获取酬金。'
                  }
            ]
        },
        errorPage:null
    }
]
export default ComConfig